export class ProductAssetsModel {
    ProductId: string;
    FileType: string;
    FileTypeValue: string;
}

export class ProductAssetsList {
    Type: string;
    FilePath: string;
    FileName: string;
    FileTitle: string;
    FileDescription: string;
    AssetId: number;
    FileType: string;
}

export class ProductAssetsResponseModel {
    ProductAssetsList: Array<ProductAssetsList> = [];
    TotalPages: number;
}

export class GetProductAssetModel {
    ProductId: number;
    AssetId: number;
    FileType: string;
    FileTypeValue: string;
    ImageLoader: boolean = true;
    Index: number;
    type: number;
    imagePath: string;
    fileTitle: string;
    filePath: string;
}

export class GetProductAssetDeleteModel {
    ProductAssetIds: string;
}

export class ProductWarrantyServiceModel {
    ProductId: number;
}

export class ProductWarrantyList {
    warrantyId: number;
    title: string;
}

export class ProductWarrantyServiceItem {
    ProductWarrantyList: Array<ProductWarrantyList> = [];
}

export class ProductWarrantyItemList {
    warrantyId: number;
    title: string;
    warrantyServiceTerm: string;
    duration: string;
    isActive: boolean;
    isSelected: boolean;
    InstallationPrice: string;
}

export class WarrantyDetailsModel {
    warrantyId: number;
    title: string;
    warrantyServiceTerm: string;
    duration: string;
    warrantyPriceId: string;
}

export class GetProductAssetSequenceModel {
    ProductId: number;
    AssestSequences:  Array<UpdateSequenceImageModel> = [];
}

export class UpdateSequenceImageModel {
    AssestId: number;
    SequenceId: number;
}

export class GetProductAssetSequence {
    ProductId: number;
}





